import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { IndividuService } from '@Common/core/services';
import { Observable } from 'rxjs';
import {rolesBdc} from '../enum/roles-bdc';


@Injectable()
export class SupergestionnaireGuardService  {
  constructor(private individuService: IndividuService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.isSupergestionnaire();
  }

  private isSupergestionnaire(): Observable<boolean> {
    return Observable.create(observer => {
      this.individuService.individu$.subscribe(_individu => {
          observer.next(this.isStaff(_individu));
          // observer.next(this.individuService.hasRole(_individu, 'supergestionnaire_bdc'));
          observer.complete();
        }
      );
    });
  }

  private isStaff(individu) {
    if (this.individuService.hasRole(individu, rolesBdc.admin) ||
      this.individuService.hasRole(individu, rolesBdc.supergestionnaire)) {
      return true;
    } else {
      return false;
    }
  }
}
